import { render, staticRenderFns } from "./displayCategory.vue?vue&type=template&id=0c589d8e&scoped=true&"
import script from "./displayCategory.vue?vue&type=script&lang=js&"
export * from "./displayCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c589d8e",
  null
  
)

export default component.exports